import { Typography } from '@material-ui/core'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import { makeStyles } from '@material-ui/styles'
import { Maybe } from '@ts/operations'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'

type StyleProps = {
  bgColor?: Maybe<string>
}

const useStyles = makeStyles<Theme, StyleProps>(({ palette, spacing }) => ({
  icon: {
    fontSize: '1rem',
    marginRight: spacing(0.5),
  },
  tagCircle: ({ bgColor }) => ({
    alignItems: 'center',
    background: bgColor ?? palette.primary.dark,
    borderRadius: '50%',
    color: palette.common.white,
    display: 'flex',
    height: '4em',
    justifyContent: 'center',
    position: 'absolute',
    right: '1.5em',
    textAlign: 'center',
    top: '-2em',
    whiteSpace: 'nowrap',
    width: '4em',
    zIndex: 1,
  }),
  tagRectangle: ({ bgColor }) => ({
    alignItems: 'center',
    background: bgColor ?? palette.secondary.main,
    borderRadius: '.25em',
    color: palette.common.white,
    display: 'flex',
    padding: '.3rem .7rem',
    position: 'absolute',
    right: '1.5em',
    top: '-.9em',
    whiteSpace: 'nowrap',
    zIndex: 1,
  }),
  textCircle: {
    color: palette.common.white,
    fontSize: '.5rem',
    letterSpacing: '.05em',
    lineHeight: '.75rem',
    textAlign: 'center',
    textTransform: 'uppercase',
    whiteSpace: 'initial',
    zIndex: 1,
  },
  textRectangle: {
    color: palette.common.white,
    fontSize: '.7rem',
    lineHeight: '0.8rem',
    textTransform: 'uppercase',
    zIndex: 1,
  },
}))

export enum Shape {
  Rectangle,
  Circle,
}

export enum Icon {
  TrendingUp,
}

const getTagComponent = (
  icon: Maybe<JSX.Element>,
  tagClass: string,
  textClass: string,
  text?: Maybe<string>
) => {
  return (
    <div className={tagClass}>
      {icon}
      {text && <Typography className={textClass}>{text}</Typography>}
    </div>
  )
}

const getTagIcon = (iconClass: string, icon?: Maybe<Icon>) => {
  return icon === Icon.TrendingUp ? <TrendingUpIcon className={iconClass} /> : null
}

export type ReleaseCardTagProps = {
  bgColor?: Maybe<string>
  icon?: Maybe<Icon>
  shape: Maybe<Shape>
  text?: Maybe<string>
}

export const ReleaseCardTag = ({ bgColor, text, shape, icon }: ReleaseCardTagProps) => {
  const classes = useStyles({ bgColor })
  const iconTag = getTagIcon(classes.icon, icon)

  switch (shape) {
    case Shape.Rectangle:
      return getTagComponent(iconTag, classes.tagRectangle, classes.textRectangle, text)
    case Shape.Circle:
      return getTagComponent(iconTag, classes.tagCircle, classes.textCircle, text)
    default:
      return getTagComponent(iconTag, classes.tagRectangle, classes.textRectangle, text)
  }
}
